var UserChannelMode = require('userchannelmode');
var sko = require('../lib/safekeyobject.es6').default;


var JoinPartFormatter = function (options) {
    this.buffer = options.buffer;
    this.lines = [options.line];
    this.rows = options.rows;
    this.formatter = options.formatter;
    this.index = options.index;
    this.spliceCount = this.rows.length;
    this.sentences = '';
    this.expanded = false;
};
JoinPartFormatter.prototype = {
    setIndex: function (index) {
        this.index = index;
    },
    getFirstLine: function () {
        return this.lines[0];
    },
    addMessage: function (line, rows) {
        if (line.get('match')) {
            this.expanded = true;
        }
        this.lines.push(line);
        this.rows.push.apply(this.rows, rows);
        // Return whether this is the first grouping we've done
        var isFirst = (this.lines.length == 2);
        if (!isFirst) {
            this.spliceCount = 2;
        }
        return isFirst;
    },
    renderMessage: function (line, rows) {
        var isFirst = this.addMessage(line, rows);
        this.render();
        return isFirst;
    },
    render: function () {
        // Collect types
        var state = new sko();
        var connState = new sko();
        var lastType = new sko();
        var mode = new sko();
        var uhost = new sko();
        var nickChange = new sko();
        var nickMessage = new sko();
        var quitOldNick = new sko();
        var leftOldNick = new sko();
        var split = new sko();
        var displayName = new sko();
        var channelMode, channelUrl;
        _.each(this.lines, function (line) {
            var type = line.get('type');
            var nc = type == 'nickchange';
            var chghost = type == 'user_chghost';
            var mc = type == 'user_channel_mode';
            var mlc = line.isNickModeListChange();
            var im, cu;
            if (type == 'channel_mode_is') {
                im = true;
                channelMode = line;
            }
            if (type == 'channel_url') {
                cu = true;
                channelUrl = line;
            }
            var nick = nc ? line.get('newnick') : line.get('nick');
            var dn = line.getDisplayName();
            var modeChange;
            if (mc || mlc) {
                var mcU;
                if (mc) {
                    mcU = line.makeUser(nick);
                } else {
                    mcU = null;
                }
                modeChange = new UserChannelMode(line.attributes, {buffer: this.buffer, user: mcU});
                // For mlc, nick is parsed out of the oplist
                nick = modeChange.user.getNick();
                dn = modeChange.user.getDisplayName();
            }
            displayName.set(nick, dn);
            var jp = type == 'joined_channel' || type == 'you_joined_channel' || type == 'parted_channel';
            var channel;
            var newState = false;
            if (jp) {
                channel = line.get('chan');
            } else if (mc || mlc) {
                channel = line.get('channel');
            }

            if (nick && !nickMessage.get(nick)) {
                nickMessage.set(nick, line);
            }

            if (nick && !state.get(nick)) {
                state.set(nick, new sko());
            }
            var nickState = state.get(nick);

            if (nick && !mode.get(nick)) {
                mode.set(nick, new sko());
            }
            if (nick && !lastType.get(nick)) {
                lastType.set(nick, new sko());
            }

            if (nc) {
                var oldNick = line.get('oldnick');
                /* Check for a reclaim */
                // Previous nick owner has quit
                if (connState.get(nick) === false) {
                    var fl;
                    nickState.each(function(qlChan, qlChanState) {
                        if (qlChanState === 0 && this.action(lastType.get(nick).get(qlChan)) != 'joined') {
                            if (!leftOldNick.get(nick)) {
                                leftOldNick.set(nick, new sko());
                            }
                            leftOldNick.get(nick).set(qlChan, 'flappedIn');
                            fl = true;
                        }
                    }, this);
                    if (!fl) {
                        quitOldNick.set(nick, 'quit');
                    }
                } else {
                    // Previous nick owner has parted
                    nickState.each(function(lChan, lChanState) {
                        if (lChanState < 0) {
                            if (!leftOldNick.get(nick)) {
                                leftOldNick.set(nick, new sko());
                            }
                            leftOldNick.get(nick).set(lChan, 'parted');
                        } else if (lChanState === 0 && this.action(lastType.get(nick).get(lChan)) != 'joined') {
                            if (!leftOldNick.get(nick)) {
                                leftOldNick.set(nick, new sko());
                            }
                            leftOldNick.get(nick).set(lChan, 'flappedIn');

                        }
                    }, this);
                }

                // Copy old state, don't fallback to current state
                state.move(oldNick, nick);
                // This nick was previously quit, make sure we decrement it properly
                if (connState.get(nick) === false && state.get(nick)) {
                    state.get(nick).each(function (chan, chanState) {
                        state.get(nick).decr(chan);
                    });
                }
                // Follow nick change trail
                nickChange.set(nick, nickChange.get(oldNick) || oldNick);
                nickChange.unset(oldNick);
                mode.move(oldNick, nick, true, function (nickUmc) {
                    nickUmc.each(function (chan, chanUmc) {
                        _.each(chanUmc, function (umc) {
                            umc.user.set('nick', nick);
                        });
                    });
                    return nickUmc;
                });
                uhost.move(oldNick, nick, true);
                nickMessage.move(oldNick, nick, true);
                lastType.move(oldNick, nick, true);
                connState.move(oldNick, nick, true);
            } else if (nick && !mc && !mlc && !im && !cu) {
                // State remains undefined for mode changes
                if (channel && nickState.get(channel) === undefined) {
                    newState = true;
                    nickState.set(channel, 0);
                }
            }

            if (!nick) {
                return;
            }
            switch (type) {
            case 'joined_channel':
            case 'you_joined_channel':
                if (connState.get(nick) === false && newState) {
                    // First join after a previous quit, so this is a pop back in
                    nickState.decr(channel);
                }
                nickState.incr(channel);
                connState.set(nick, true);
                break;
            case 'parted_channel':
                nickState.decr(channel);
                connState.set(nick, true);
                break;
            case 'quit':
                nickState.each(function (chan, chanState) {
                    nickState.decr(chan);
                });
                lastType.get(nick).each(function (chan, t) {
                    if (t != 'parted_channel') {
                        lastType.get(nick).set(chan, type);
                    }
                });
                if (line.isNetSplit()) {
                    split.set(nick, line.get('msg'));
                }
                connState.set(nick, false);
                break;
            case 'nickchange':
                connState.set(nick, true);
                break;
            }
            if (modeChange) {
                if (!mode.get(nick).get(channel)) {
                    mode.get(nick).set(channel, []);
                }
                mode.get(nick).get(channel).push(modeChange);
                connState.set(nick, true);
            }
            if (chghost) {
                uhost.set(nick, line);
                connState.set(nick, true);
            }
            if (channel && nick) {
                lastType.get(nick).set(channel, type);
            }
        }, this);
        var actions = JoinPartFormatter.initActions();
        // Process actions from state
        var a;
        state.each(function (nick, nickState) {
            a = null;
            if (!nickState || nickState.isEmpty()) {
                // Empty object, just a mode/nick change/host change/quit
                if (nickChange.get(nick)) {
                    // Quit after nick
                    if (!connState.get(nick)) {
                        a = actions.quit;
                    } else {
                        actions.nickchange.changes.set(nick, nickChange.get(nick));
                    }
                } else if (mode.get(nick) && !mode.get(nick).isEmpty()) {
                    mode.get(nick).each(function(modeChan, modeChanList) {
                        // Quit after mode change
                        if (!connState.get(nick)) {
                            a = actions.quit;
                        } else {
                            a = actions.user_channel_mode;
                        }
                        a.chans.push(modeChan);
                    });
                } else if (uhost.get(nick)) {
                    // Quit after host change
                    if (!connState.get(nick)) {
                        a = actions.quit;
                    }
                } else {
                    a = actions.quit;
                }
                if (a) {
                    a.list.push(nick);
                }
            } else {
                nickState.each(function (chan, chanState) {
                    if (chanState === 0) {
                        // Check last action indicates they are still in the channel
                        if (this.action(lastType.get(nick).get(chan)) == 'joined' && connState.get(nick)) {
                            a = actions.flappedOut;
                            a.chans.push(chan);
                        } else {
                            a = actions.flappedIn;
                            a.chans.push(chan);
                        }
                    } else {
                        a = actions[this.action(lastType.get(nick).get(chan))];
                        if (a && a.chans) {
                            a.chans.push(chan);
                        }
                    }
                    if (a) {
                        if (!_.contains(a.list, nick)) {
                            a.list.push(nick);
                        }
                    }
                }, this);
            }
        }, this);
        quitOldNick.each(function (qNick, qNickAction) {
            if (!state.get(qNick)) {
                actions[qNickAction].list.push(qNick);
            }
        });
        leftOldNick.each(function (lNick, lNickChans) {
            if (!state.get(lNick)) {
                lNickChans.each(function (lNickChan, lNickChanAction) {
                    actions[lNickChanAction].chans.push(lNickChan);
                    actions[lNickChanAction].list.push(lNick);
                });
            }
        });

        this.sentences = JoinPartFormatter.sentence(this.buildSentences(actions, channelUrl, channelMode, mode, uhost, nickChange, nickMessage, quitOldNick, leftOldNick, split, displayName));

        return this;
    },

    formatNetsplits: function (hosts) {
        return _.map(hosts, function (host) {
            return this.formatter.escapeText(host).replace(' ', ' ' + JoinPartFormatter.prefix('⇎'));
        }, this).join(', ') + ' ';
    },
    buildSentences: function (actions, channelUrl, channelMode, mode, uhost, nickChange, nickMessage, quitOldNick, leftOldNick, split, displayName) {
        var msg = '';
        if (split.length() > 1) {
            msg += this.formatNetsplits(_.unique(split.values()));
        }
        _.each(['joined', 'parted', 'quit', 'user_channel_mode', 'flappedIn', 'flappedOut'], function (type, i) {
            var action = actions[type];
            if (!action.list.length) {
                return;
            }
            if (msg && type == 'user_channel_mode') {
                // Add a bullet point prefix for mode changes if there's other lines before
                msg += JoinPartFormatter.divider();
            }
            msg += JoinPartFormatter.prefix(action.prefix);
            msg += this.formatter.listSentence(action.list, {
                render: _.bind(function (nick, j) {
                    var renderM = '';
                    var chan = action.chans && action.chans[j];
                    var quitNick = (type == 'quit') && quitOldNick.has(nick);
                    var leftNick = (type == 'parted' || type == 'flappedIn') && leftOldNick.has(nick) && leftOldNick.get(nick).has(chan);

                    if (quitNick || leftNick) {
                        renderM += this.formatter.render(nick);
                    } else if (this.buffer.isChannel() && mode.get(nick).has(chan)) {
                        renderM += this.formatter.linkUserMode(_.last(mode.get(nick).get(chan)).user, {
                            name: displayName.get(nick)
                        });
                    } else {
                        renderM += this.formatter.linkMessageUser(nick, nickMessage.get(nick));
                    }
                    if (!quitNick && !leftNick) {
                        var changedNick = nickChange.get(nick) && nickChange.get(nick) != nick;
                        if ((this.buffer.isChannel() && mode.get(nick).has(chan)) || changedNick) {
                            renderM += ' (';
                        }
                        if (changedNick) {
                            renderM += 'was ' + this.formatter.render(nickChange.get(nick));
                            if (this.buffer.isChannel() && mode.get(nick).has(chan)) {
                                renderM += '; ';
                            }
                        }
                        if (this.buffer.isChannel() && mode.get(nick).has(chan)) {
                            renderM += '<span class="mode">' + UserChannelMode.getActions(mode.get(nick).get(chan)) + '</span>';
                        }
                        if ((this.buffer.isChannel() && mode.get(nick).has(chan)) || changedNick) {
                            renderM += ')';
                        }
                    }
                    return renderM;
                }, this)
            });
            if (action.suffix) {
                msg += ' ' + action.suffix;
            }
            if (this.buffer.isConversation() && type != 'quit') {
                var chans = action.chans;
                if (action.chans.length) {
                    msg += ' ' + this.formatter.listSentence(chans, {
                        render: _.bind(function (chan, j) {
                            return this.formatter.linkChannel(chan);
                        }, this)
                    });
                }
            }
            msg += JoinPartFormatter.spacing();
        }, this);
        var nickChangeParts = [];
        var part;
        actions.nickchange.changes.each(function (nick, oldNick) {
            part  = this.formatter.render(oldNick);
            part += ' ' + JoinPartFormatter.prefix('→');

            if (this.buffer.isChannel() && mode.get(nick).has(this.buffer.getName())) {
                mode.get(nick).each(function (modeChan, modeChanList) {
                    part += this.formatter.linkUserMode(_.last(modeChanList).user, {
                        name: displayName.get(nick)
                    });
                    part += ' (<span class="mode">' + UserChannelMode.getActions(modeChanList) + '</span>) ';
                }, this);
            } else {
                part += this.formatter.linkMessageUser(nick, nickMessage.get(nick));
            }

            nickChangeParts.push(part);
        }, this);
        if (nickChangeParts.length) {
            if (msg) {
                // Add a bullet point prefix for nick changes if there's other lines before
                msg += JoinPartFormatter.divider();
            }
            msg += nickChangeParts.join(', ');
            msg += JoinPartFormatter.spacing();
        }
        if (channelMode && channelMode.get('newmode')) {
            if (msg) {
                // Add a bullet point prefix for channel mode changes if there's other lines before
                msg += JoinPartFormatter.divider();
            }
            msg += 'Channel mode: <b>+' + this.formatter.render(channelMode.get('newmode')) + '</b>';
            msg += JoinPartFormatter.spacing();
        }
        if (channelUrl) {
            if (msg) {
                // Add a bullet point prefix for channel url changes if there's other lines before
                msg += JoinPartFormatter.divider();
            }
            msg += 'Channel homepage: ' + this.formatter.renderLinkify(channelUrl.get('url'));
            msg += JoinPartFormatter.spacing();
        }
        if (!uhost.isEmpty()) {
            if (msg) {
                // Add a bullet point prefix for host changes if there's other lines before
                msg += JoinPartFormatter.divider();
            }
            msg += JoinPartFormatter.prefix(actions.user_chghost.prefix);
            msg += this.formatter.listSentence(uhost.entries(), {
                render: _.bind(function (entry, i) {
                    return this.formatter.linkMessageUser(entry[0], entry[1]);
                }, this)
            });
            msg += JoinPartFormatter.spacing();
        }
        if (channelMode && !channelMode.get('newmode') && !msg) {
            msg += 'No channel mode';
        }
        return msg;
    },
    action: function (action) {
        switch (action) {
        case 'joined_channel':
        case 'you_joined_channel':
        case 'user_channel_mode':
        case 'channel_mode_list_change':
        case 'nickchange':
            return 'joined';
        case 'parted_channel':
            return 'parted';
        case 'quit':
            return 'quit';
        }
        return null;
    }
};

JoinPartFormatter.prefix = function (character) {
    return '<span class="prefix">' + character + '</span> ';
};
JoinPartFormatter.sentence = function (content) {
    return '<span class="sentence">' + content + '</span>';
};
JoinPartFormatter.spacing = function () {
    return '&nbsp;&nbsp;';
};
JoinPartFormatter.divider = function () {
    return '•' + JoinPartFormatter.spacing();
};
JoinPartFormatter.initActions = function () {
    return {
        joined: {
            list: [],
            chans: [],
            prefix: '→',
            suffix: 'joined'
        },
        parted: {
            list: [],
            chans: [],
            prefix: '←',
            suffix: 'left'
        },
        quit: {
            list: [],
            chans: [],
            prefix: '⇐',
            suffix: 'quit'
        },
        user_channel_mode: {
            list: [],
            chans: [],
            prefix: 'mode:',
            suffix: ''
        },
        user_chghost: {
            list: [],
            chans: [],
            prefix: 'host change:',
            suffix: ''
        },
        flappedOut: {
            list: [],
            chans: [],
            prefix: '↔',
            suffix: 'nipped out'
        },
        flappedIn: {
            list: [],
            chans: [],
            prefix: '↔',
            suffix: 'popped in'
        },
        nickchange: {
            changes: new sko()
        }
    };
};

module.exports = JoinPartFormatter;



//////////////////
// WEBPACK FOOTER
// ./app/src/format/joinpartformatter.js
// module id = RTnb
// module chunks = 1